var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { convertStyleValue } from '../../utils/js-style-to-css';
var Sticky = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: sticky;\n  top: ", ";\n  right: ", ";\n  bottom: ", ";\n  left: ", ";\n"])), function (props) {
  return convertStyleValue(props.top, 'top');
}, function (props) {
  return convertStyleValue(props.right, 'right');
}, function (props) {
  return convertStyleValue(props.bottom, 'bottom');
}, function (props) {
  return convertStyleValue(props.left, 'left');
});
Sticky.propTypes = {
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object
};
Sticky.defaultProps = {
  top: '',
  right: '',
  bottom: '',
  left: '',
  style: {}
};
export default Sticky;